import React from "react";

const Button = ({ text, onClick, className = "", style = {} }) => {
  return (
    <button
      className={`px-6 h-[40px] text-white font-montserrat text-sm font-semibold rounded-md shadow-md transition-all duration-300 active:scale-95 flex items-center justify-center ${className}`}
      style={{
        backgroundColor: style.backgroundColor || "#4CAF50",
        ...style,
      }}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export default Button;
